import { Loader } from '@/components/Loader'
import { paths } from '@/constants/paths'
import { Calendar } from '@/containers/Calendar/Calendar'
import { ErrorNotFound } from '@/containers/ErrorNotFound'
import { Favorites } from '@/containers/Favorites/Favorites'
import { FocusPage } from '@/containers/FocusPage'
import { HomePage } from '@/containers/HomePage'
import { HomePageWithStage } from '@/containers/HomePageWithStage/HomePageWithStage'
import { Search } from '@/containers/Search/Search'
import { Selected } from '@/containers/Selected/Selected'
import { SpecialHomePage } from '@/containers/SpecialHomePage/SpecialHomePage'
import { SportsPage } from '@/containers/SportsPage/SportsPage'
import { Subscriptions } from '@/containers/Subscriptions'

import { RouteConfig } from './routes'

export const mainLayoutRoutes: RouteConfig[] = [
  {
    path: paths.INDEX,
    element: <Loader />,
  },
  {
    path: paths.HOME,
    element: <HomePageWithStage />,
  },
  {
    path: paths.CLASSIC_HOME,
    element: <HomePage />,
  },
  {
    path: paths.SPECIAL_HOME,
    element: <SpecialHomePage />,
  },
  {
    path: paths.SEARCH,
    element: <Search />,
  },
  {
    path: paths.SPORTS,
    element: <SportsPage />,
  },
  {
    path: paths.CALENDAR,
    element: <Calendar />,
  },
  {
    path: paths.FAVORITES,
    element: <Favorites />,
  },
  {
    path: paths.SELECTED_PAGE,
    element: <Selected />,
  },
  {
    path: paths.FOCUS_PAGE,
    element: <FocusPage />,
  },
  {
    path: paths.SUBSCRIPTIONS,
    element: <Subscriptions />,
  },
  {
    path: paths.OFFERS,
    element: <Subscriptions />,
  },
  {
    path: paths.NOT_FOUND,
    element: <ErrorNotFound />,
  },
]
